import Vue from 'vue';
import VueRouter from 'vue-router';
import MainWrapper from './components/MainWrapper.vue';
import Home from './components/Home.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '',
        component: MainWrapper,
        children: [
            {
                path: '/',
                name: 'home',
                component: Home,
            },
            {
                path: '/code*',
                name: 'home-with-code',
                component: Home,
                meta: { isAuthenticated: true }
            }
        ],
    },
];

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes,
});

router.afterEach((toRoute, fromRoute) => {
    window.document.title = 'Microsite Start ' + process.env.VUE_APP_APPLICATION_MODE.toUpperCase();
});

export default router;
